import { useLocation } from 'react-router-dom';
import s from './Menu.module.css';

const VoitingButton = () => {
  const { pathname } = useLocation();

  return (
    <>
      <div className={s.panel__container}>
        <div
          className={
            pathname === '/voiting'
              ? s.voiting__image__active
              : s.voiting__image
          }
        ></div>
        <div
          className={
            pathname === '/voiting'
              ? s.voiting__buttonActive
              : s.voiting__button
          }
        >
          Voiting
        </div>
      </div>
    </>
  );
};

export { VoitingButton };
